export const IMAGE_UPLOAD = "image_file";
export const GIF_UPLOAD = "gif_file";
export const VIDEO_UPLOAD = "video_file";
export const YOUTUBE_URL = "youtube_url";
export const PDF_UPLOAD = "pdf_file";
export const EMOJI_LEAVE = "emoji_leave";



// WEBPACK FOOTER //
// ./src/Constants/types.js